import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { createApiUrl } from '../utils/apiConfig';
import './RequestPasswordReset.css';

const RequestPasswordReset = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const navigate = useNavigate();

  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', handleOnlineStatus);
    window.addEventListener('offline', handleOnlineStatus);

    return () => {
      window.removeEventListener('online', handleOnlineStatus);
      window.removeEventListener('offline', handleOnlineStatus);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(createApiUrl('/api/request-password-reset'), { email });
      setMessage(response.data.message);
      if (response.data.success) {
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (error) {
      setMessage(error.response?.data?.message || 'An error occurred. Please try again.');
    }
  };

  return (
    <div className="requestPasswordResetContainer">
      <h1 className="requestPasswordResetHeading">Request<br />Password Reset</h1>
      <div className="requestPasswordResetCard">
        {!isOnline && (
          <div className="alert alert-warning">You are currently offline</div>
        )}
        {message && (
          <div className="alert alert-danger">{message}</div>
        )}
        <form onSubmit={handleSubmit} className="requestPasswordResetForm">
          <div className="formField">
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="formInput"
              required
              placeholder="Email Address"
            />
            <label htmlFor="email" className="formLabel">Email Address:</label>
          </div>
          <button type="submit" className="submitButton">
            Send Reset Link
          </button>
        </form>
        <div className="registerFooter">
          <span>Already have an account? <Link to="/login">Login</Link></span>
        </div>
      </div>
    </div>
  );
};

export default RequestPasswordReset; 